import dynamic from 'next/dynamic'
import { LocationVisitsIcon } from 'src/components/insights/icons/location-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/day-of-week.png'

const DayOfWeekVisits = dynamic(() => import('src/components/insights/location-visits/day-of-week'), { ssr: false })

export const DayOfWeekWidget: InsightBuilderWidget = {
  id: 'day-of-week',
  name: 'Day of Week (Visits Distribution)',
  type: 'Location Visits',
  icon: LocationVisitsIcon,
  component: DayOfWeekVisits,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
